// const ADD_ORDER = "add-order"
const WABOX_TABLE_READY_STATUS = "wabox-table-ready-status"

const SEARCH_TEXT_STATE_UPDATE = "wabox-table-search-text-state-update"
const ROWS_PER_PAGE_STATE_UPDATE = "wabox-table-rows-per-page-state-update"
const PAGINATION_UPDATE = "wabox-table-pagination-update"
const LAST_RECORDED_TIME = "wabox-table-last-recorded-time"

const WABOX_ID_FOR_ACTION = "wabox-table-wabox-id-for-action"
const DATE_UPDATE_FOR_STATE_MAINTENANCE ="wabox-table-date-update-for-state-maintenance"

const PUSH_MESSAGE_VALUE = "wabox-table-push-message-value"


const initialState = {
    // orderData: [],
    isWaboxTableReady:true,
    wabox:{},
    pushMessageUpdate:null,
    previousStartDateState: "",
    previousEndDateState: "",
    previousSearchFieldText: "",
    previousSizePerPageValue: 15,
    previousPaginationState: 1,
    waboxIdForAction:null
    

}

export default function reducer(state = initialState, action) {
    let duplicateState = null

    switch (action.type) {
        case WABOX_TABLE_READY_STATUS:
            return Object.assign({}, state, { isWaboxTableReady: action.payload })
            

        
        case WABOX_ID_FOR_ACTION:
            return Object.assign({},state,{waboxIdForAction:action.payload})
        
        case LAST_RECORDED_TIME:
            return Object.assign({}, state, { lastRecordedTime: action.payload })
        
        case DATE_UPDATE_FOR_STATE_MAINTENANCE:
            duplicateState = Object.assign({}, state)
            duplicateState.previousStartDateState = action.payload.start_date
            duplicateState.previousEndDateState = action.payload.end_date
            return Object.assign({}, state, duplicateState)

        case SEARCH_TEXT_STATE_UPDATE:
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)

        case ROWS_PER_PAGE_STATE_UPDATE:
            duplicateState = Object.assign({}, state)
            duplicateState.previousSizePerPageValue = action.payload
            return Object.assign({}, state, duplicateState)

        case PAGINATION_UPDATE:
            duplicateState = Object.assign({}, state)
            duplicateState.previousPaginationState = action.payload
            return Object.assign({}, state, duplicateState)

        case PUSH_MESSAGE_VALUE:
            return Object.assign({}, state, { pushMessageUpdate: action.payload })

        default:
            return state
    }
}



export function waboxTableReady(data) {
    return {
        type: WABOX_TABLE_READY_STATUS,
        payload: data
    }
}

export function pushMessageUpdate(value){
    return{
        type: PUSH_MESSAGE_VALUE,
        payload:value
    }
}


export function lastRecordedTime(data) {
    return {
        type: LAST_RECORDED_TIME,
        payload: data
    }
}



export function waboxIdForAction(id){
    return{
        type:WABOX_ID_FOR_ACTION,
        payload:id
    }
}
export function selectedDateUpdate(data) {
    return {
        type: DATE_UPDATE_FOR_STATE_MAINTENANCE,
        payload: data
    }
}

export function selectedSearchTextUpdate(text) {
    return {
        type: SEARCH_TEXT_STATE_UPDATE,
        payload: text
    }
}

export function selectedSizePerPageUpdate(text) {
    return {
        type: ROWS_PER_PAGE_STATE_UPDATE,
        payload: text
    }
}

export function selectedPaginationUpdate(text) {
    return {
        type: PAGINATION_UPDATE,
        payload: text
    }
}




// WEBPACK FOOTER //
// ./src/modules/Wabox/redux/wabox.js